import ChooseProfileScreen from "./chooseProfileScreen";

export default ChooseProfileScreen;
